import { Editor } from '@tiptap/react';
import { useEffect, useRef,useState } from 'react';

import classes from './ImagePopup.module.scss';

interface ImagePopupProps {
	editor: Editor | null;
	isOpen: boolean;
	onClose: () => void;
	buttonRef: React.RefObject<HTMLDivElement | null>;
}

interface ImageData {
	url: string;
	alt: string;
}

const ImagePopup = ({ editor, isOpen, onClose, buttonRef }: ImagePopupProps) => {
	const [imageData, setImageData] = useState<ImageData>({ url: '', alt: '' });
	const popupRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (isOpen) {
			setImageData({ url: '', alt: '' });
		}
	}, [isOpen]);

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (
				popupRef.current &&
				!popupRef.current.contains(event.target as Node) &&
				buttonRef.current &&
				!buttonRef.current.contains(event.target as Node)
			) {
				onClose();
			}
		};

		if (isOpen) {
			document.addEventListener('mousedown', handleClickOutside);
		}

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [isOpen, onClose, buttonRef]);

	const handleInsertImage = () => {
		if (imageData.url.trim() && editor) {
			editor
				.chain()
				.focus()
				.setImage({
					src: imageData.url,
					alt: imageData.alt || '',
					title: imageData.alt || '',
				})
				.run();
			onClose();
			setImageData({ url: '', alt: '' });
		}
	};

	if (!isOpen) return null;

	return (
		<div ref={popupRef} className={classes.imagePopup} onClick={(e) => e.stopPropagation()}>
			<div className={classes.popupContent}>
				<div className={classes.formGroup}>
					<label htmlFor='image-url'>Ссылка на изображение:</label>
					<input
						id='image-url'
						type='url'
						value={imageData.url}
						onChange={(e) => setImageData({ ...imageData, url: e.target.value })}
						placeholder='https://example.com/image.jpg'
						className={classes.input}
						autoFocus
					/>
				</div>
				<div className={classes.formGroup}>
					<label htmlFor='image-alt'>Описание изображения:</label>
					<input
						id='image-alt'
						type='text'
						value={imageData.alt}
						onChange={(e) => setImageData({ ...imageData, alt: e.target.value })}
						placeholder='Описание изображения'
						className={classes.input}
					/>
				</div>
			</div>
			<div className={classes.popupActions}>
				<button
					type='button'
					className={`${classes.button} ${classes.buttonSecondary}`}
					onClick={onClose}
				>
					Отмена
				</button>
				<button
					type='button'
					className={`${classes.button} ${classes.buttonPrimary}`}
					onClick={handleInsertImage}
					disabled={!imageData.url.trim()}
				>
					Вставить
				</button>
			</div>
		</div>
	);
};

export default ImagePopup;
